import { Box, FormControl, FormControlLabel, MenuItem, Switch, Typography } from '@mui/material';
import { CustomTextField } from '../../components/Inputs';
import { STPSelect } from '../../components/Select';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { getFormaPago } from '../../services/getFormaPago';
import { getPoblaciones } from '../../services/getPoblaciones';

export function BancariesFields({ formData, handleInputChange, fieldErrors }) {
  const { t } = useTranslation();
  const [formasPago, setFormasPago] = useState([]);
  const [poblaciones, setPoblaciones] = useState([]);

  // Función para ordenar los arrays recibidos en orden alfabético
  const sortByName = (array) => {
    return array.sort((a, b) => {
      if (a.nombre) {
          if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
            return -1;
          }
          if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
            return 1;
          }
          return 0;
        }
      else if (a.valor) {
          if (a.valor.toLowerCase() < b.valor.toLowerCase()) {
            return -1;
          }
          if (a.valor.toLowerCase() > b.valor.toLowerCase()) {
            return 1;
          }
          return 0;
        }
      });
    }

  useEffect(() => {
    getFormaPago()
    .then(response => {
      setFormasPago(response.data);
    })
    .catch(error => {
      console.error('Error fetching formas de pago:', error);
    });
    getPoblaciones()
    .then(response => {
      const data = sortByName(response);
      setPoblaciones(data);
    })
    .catch(error => {
      console.error('Error fetching poblaciones:', error);
    });
  }, []);

  const handleIbanChange = (iban) => {
    // Eliminar guiones y espacios en el IBAN
    const ibanFormatted = iban.replace(/[^a-zA-Z0-9]/g, '');

    handleInputChange('iban', ibanFormatted);

  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="subtitle1" sx={{ fontWeight:'bold', color: 'black', ml: '12px', mr: '12px', width:'700px' }}>
          {t('bankingFields.cashPayment')}
        </Typography>
        <FormControl fullWidth>
          <STPSelect
            value={formData.pagament_efectiu}
            onChange={(e) => handleInputChange('pagament_efectiu', e.target.value)}
          >
            <MenuItem value={1}>{t('bankingFields.yes')}</MenuItem>
            <MenuItem value={0}>{t('bankingFields.no')}</MenuItem>
          </STPSelect>
        </FormControl>
      </Box>

      <CustomTextField
        fullWidth
        label={t('bankingFields.accountHolderName')}
        variant="outlined"
        margin='normal'
        size="md"
        value={formData.nomTitular}
        error={!!fieldErrors.nomTitular}
        helperText={fieldErrors.nomTitular}
        onChange={(e) => handleInputChange('nomTitular', e.target.value)}
      />

      <CustomTextField
        fullWidth
        label={t('bankingFields.accountHolderNIF')}
        variant="outlined"
        margin='normal'
        size="md"
        value={formData.nifTitular}
        error={!!fieldErrors.nifTitular}
        helperText={fieldErrors.nifTitular}
        onChange={(e) => handleInputChange('nifTitular', e.target.value)}
      />

      <CustomTextField
        fullWidth
        label={t('bankingFields.address')}
        variant="outlined"
        margin='normal'
        size="md"
        value={formData.adressaTitular}
        error={!!fieldErrors.adressaTitular}
        helperText={fieldErrors.adressaTitular}
        onChange={(e) => handleInputChange('adressaTitular', e.target.value)}
      />

      <CustomTextField
        fullWidth
        label={t('bankingFields.postalCode')}
        variant="outlined"
        margin='normal'
        size="md"
        value={formData.codiPostalTitular}
        error={!!fieldErrors.codiPostalTitular}
        helperText={fieldErrors.codiPostalTitular}
        onChange={(e) => handleInputChange('codiPostalTitular', e.target.value)}
      />

      <FormControl fullWidth variant="outlined" margin="normal">
        <Typography variant="subtitle1" sx={{ fontWeight:'bold', color: 'black', ml: '12px' }}>
          {t('bankingFields.city')}:
        </Typography>
        <STPSelect
          value={formData.poblacioTitular}
          onChange={(e) => handleInputChange('poblacioTitular', e.target.value)}
        >
          <MenuItem value="">
            {t('bankingFields.city')}
          </MenuItem>
          {poblaciones && poblaciones.length > 0 && poblaciones.map((poblacion) => (
            <MenuItem key={poblacion.clave} value={poblacion.clave}>
              {poblacion.valor}
            </MenuItem>
          ))}
        </STPSelect>
      </FormControl>

      <CustomTextField
        fullWidth
        label={t('bankingFields.iban')}
        variant="outlined"
        margin='normal'
        size="md"
        value={formData.iban}
        onChange={(e) => handleIbanChange(e.target.value)}
        error={!!fieldErrors.iban} 
        helperText={fieldErrors.iban}
      />
    </>
  );
}
